import { Switch as ChakraSwitch } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type SwitchProps = ComponentPropsWithRef<typeof ChakraSwitch>;

export function Switch(props: SwitchProps) {
  return <ChakraSwitch {...props} />;
}
